import PropTypes from "prop-types";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { z } from "zod";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { BaseForm, FormRecordPicker } from "components/BaseForm";
import EntityService from "services/Entity";

const schema = z.object({
  entity_id: z.number({
    required_error: "Entity is required",
    invalid_type_error: "Entity is required",
  }),
});

const fetchEntities = search =>
  EntityService.getEntitiesForFilters({ ...(search && { search }) });

/** Moves the selected Contacts to another Entity. */
const TransferContactsDialog = ({
  open,
  onOpenChange,
  contactIds,
  onSaved,
}) => {
  const transferContacts = useMutation({
    mutationFn: ({ entity_id }) =>
      EntityService.transferContacts(entity_id, contactIds),
  });

  const handleSuccess = () => {
    onOpenChange(false);
    toast.success("Contacts transferred");
    onSaved();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="tw:sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Move Contacts to Entity</DialogTitle>
        </DialogHeader>
        <BaseForm
          schema={schema}
          defaultValues={{ entity_id: null }}
          onSubmit={transferContacts.mutateAsync}
          onSuccess={handleSuccess}
          onCancel={() => onOpenChange(false)}
          submitButtonText="Transfer"
        >
          <FormRecordPicker
            name="entity_id"
            label="Entity"
            required
            fetchOptions={fetchEntities}
            placeholder="Search entities…"
          />
        </BaseForm>
      </DialogContent>
    </Dialog>
  );
};

TransferContactsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  contactIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onSaved: PropTypes.func.isRequired,
};

export default TransferContactsDialog;
